export const KB_URL = "http://help.consigncloud.com"

export const CLEAR_ROOT_STATE = "CLEAR_ROOT_STATE"
export const RESET_AUTO_LOGOUT_TIMER = "RESET_AUTO_LOGOUT_TIMER"
